<template>
  <div id="books">
    <el-row>
      <h3 style="display:inline-block;">本の管理</h3>
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        style="float:right;margin-top:20px;"
        :total="totalCount()"
        :page-sizes="[8, 20, 40]"
        :page-size="limit"
        @current-change="changeCurrent"
        @size-change="changeSize">
      </el-pagination>
      <div class="showing">{{startCount}}-{{endCount}}</div>
    </el-row>
    <el-row>
      <el-col v-for="(book, index) in $store.state.Books.books" :key="book.id" style="margin-bottom:24px;"
         :md="{span:5, offset:(index===0||index%4===0) ? 0 : 1}"
         :sm="{span:10, offset:(index===0||index%2===0) ? 0 : 2}"
      >
        <el-card :body-style="{ padding: '0px' }">
          <img v-if="book.is_image_only==='1' && book.thumbnail" :src="book.thumbnail" style="height:220px;width:100%;" class="image">
          <div v-else class="cover_content"><div>{{book.title}}</div></div>
          <div style="padding: 14px;">
            <span>{{book.title}}</span>
            <div class="bottom clearfix">
              <!-- <el-button type="text" class="button" @click="copy(book)">コピー</el-button> -->
              <el-button type="text" class="button" @click="edit(book)">編集</el-button>
              <el-button type="text" class="button" style="float:right;color:red;" @click="remove(book)">削除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'books',
  data () {
    return {
      books: [],
      page: 1,
      limit: 8
    }
  },
  created () {
    console.log('books::created')
    this.fetchBooks()
  },
  computed: {
    startCount () {
      if (this.totalCount() > 0) {
        return (this.page - 1) * this.limit + 1
      } else {
        return 0
      }
    },
    endCount () {
      if (this.totalCount() < this.page * this.limit) {
        return this.totalCount()
      } else {
        return this.page * this.limit
      }
    }
  },
  methods: {
    fetchBooks () {
      this.$store.dispatch('Books/fetch', {'page': this.page, 'limit': this.limit})
    },
    changeCurrent (val) {
      this.page = val
      this.fetchBooks()
    },
    changeSize (val) {
      this.limit = val
      this.fetchBooks()
    },
    totalCount () {
      if (this.$store.state.Books.books.length > 0) {
        return this.$store.state.Books.books[0].totalcount
      } else {
        return 0
      }
    },
    edit (book) {
      this.$router.push('/books/' + book.id + '/cover')
    },
    // copy (book) {
    //   console.log('copy:' + book.id)
    // },
    remove (book) {
      this.$confirm('「' + book.title + '」を削除します。よろしいですか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        var self = this
        this.$store.dispatch('Books/delete', {'id': book.id}).then(function (response) {
          self.successMessage(response.message)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.showing{
  float: right;
  margin-top: 28px;
  font-size: 13px;
  color: #606266;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.cover_content{
  display:table;
  text-align:center;
  height:220px;
  width:100%;
}
.cover_content>div{
  display:table-cell;
  vertical-align:middle;
  background:#f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/04-pages/Books.vue